var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('abtest-table',_vm._b({attrs:{"update-route":true}},'abtest-table',_vm.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }